import { createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../../api/apiServises';
import {
  ADD_SHEET_METAL,
  DELETE_METAL_SHEET_DATA,
  FETCH_SHEET_METAL,
  PRINT_METAL_SHEET,
  DELETE_SHEET_METAL_DATA,

  // UPDATE_METAL_SHEET_DATA,
} from '../../../api/apiConstant';

export const addSheetMetal = createAsyncThunk(
  'metalSheet/addSheetMetal',
  async (data, { rejectWithValue }) => {
    try {
      const response = await api.post(ADD_SHEET_METAL, data);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || error.message || 'Failed to save sheet metal',
      );
    }
  },
);

export const fetchSheetMetalList = createAsyncThunk(
  'metalSheet/fetchSheetMetalList',
  async (params, { rejectWithValue }) => {
    try {
      const response = await api.get(FETCH_SHEET_METAL, { params: { ...params } });
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || error.message || 'Failed to fetch sheet metal list',
      );
    }
  },
);

export const deleteSheetMetal = createAsyncThunk(
  'metalSheet/deleteSheetMetal',
  async (id, { rejectWithValue }) => {
    try {
      const response = await api.delete(`${DELETE_METAL_SHEET_DATA}/${id}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || error.message || 'Failed to delete sheet metal',
      );
    }
  },
);

export const updateSheetMetal = createAsyncThunk(
  'metalSheet/updateSheetMetal',
  async ({ id, formData }, { rejectWithValue }) => {
    try {
      let response;
      if (id) {
        const updateData = { ...formData, id };
        response = await api.post(ADD_SHEET_METAL, updateData);
      } else {
        response = await api.post(ADD_SHEET_METAL, formData);
      }
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || error.message || 'Failed to update sheet metal',
      );
    }
  },
);

export const printMetalSheet = createAsyncThunk(
  'metalSheet/printMetalSheet',
  async (data, { rejectWithValue }) => {
    try {
      const response = await api.post(PRINT_METAL_SHEET, data, {
        responseType: 'blob',
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || error.message || 'Failed to print metal sheet',
      );
    }
  },
);

export const deleteMetalSheet = createAsyncThunk(
  'furnishing/deleteMetalSheet',
  async (id, { rejectWithValue }) => {
    try {
      const response = await api.delete(`${DELETE_SHEET_METAL_DATA}/${id}`);
      return response;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message || 'Delete Failed');
    }
  },
);
